import request from "@/utils/request.js";
/**
 * 忘记密码获取token
 * @param params
 * @returns {AxiosPromise}
 */
export function getTokenByCode(params) {
  return request({
    url: "/userService/api/app/userNurse/forgetPasswordVerifyCode",
    method: "post",
    data: params
  });
}
/**
 * 登陆
 * @param params
 * @returns {AxiosPromise}
 */
export function loginPhoneVerifyCode(params) {
  return request({
    url: "/userService/api/app/user/nurse/login/loginPhoneVerifyCode",
    method: "post",
    data: params
  });
}
